import React from 'react'
import { Modal, Grid } from 'antd'
import ExportReportForm from './ExportReportForm'

const ExportReportModal = (props) => {
    const {
        isOpen = false,
        setOpen = () => {},
        onExport = () => {},
        exporting = false,
    } = props

    const screens = Grid.useBreakpoint()
    // Responsive width: wide on desktop, near-full on mobile
    const modalWidth = screens.lg ? 720 : screens.md ? 640 : '92%'

    return (
        <Modal
            closable
            open={isOpen}
            onCancel={() => setOpen(false)}
            destroyOnClose
            width={modalWidth}
            footer={null}
            centered
            title="Export Report"
            maskClosable={false}
            styles={{
                body: {
                    paddingTop: 15,
                    maxHeight: '70vh',
                    overflowY: 'auto', // prevent content from escaping
                },
            }}
        >
            <ExportReportForm
                onExport={onExport}
                exporting={exporting}
                setOpen={setOpen}
            />
        </Modal>
    )
}

export default ExportReportModal
